import { render, staticRenderFns } from "./SendUnlockInstructions.vue?vue&type=template&id=1274b05f&scoped=true&"
import script from "./SendUnlockInstructions.vue?vue&type=script&lang=ts&"
export * from "./SendUnlockInstructions.vue?vue&type=script&lang=ts&"
import style0 from "./SendUnlockInstructions.vue?vue&type=style&index=0&id=1274b05f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274b05f",
  null
  
)

export default component.exports